import React from 'react';
import { AccountTypeSelect } from '../../components/AccountTypeSelect/AccountTypeSelect';
import { InstitutionNameInput } from '../../components/InstitutionNameInput/InstitutionNameInput';
import { AccountOwnerSelect } from '../../components/AccountOwnerSelect/AccountOwnerSelect';
import { AccountDescription } from '../../components/AccountDescription/AccountDescription';
import { TabWrapper } from '../../AccountForm.styles';
import { FormComponentProps } from '../../AccountForm.meta';
import { TabsContent } from '../../components/TabsContent/TabsContent';
import { Balance } from '../../components/Balance/Balance';
import { AccountEarmark } from '../../components/AccountEarmark/AccountEarmark';
import { Contributions } from '../../components/Contributions/Contributions';
import { AssetBucketing } from '../../components/AssetBucketing/AssetBucketing';
import { BrokerOfRecord } from '../../components/BrokerOfRecord/BrokerOfRecord';
import { Liquidity } from '../../components/Liquidity/Liquidity';
import { GrossEstateCheckbox } from '../../components/GrossEstateCheckbox/GrossEstateCheckbox';
import { ManagementStyle } from '../../components/ManagementStyle/ManagementStyle';
import { AccountNickname } from '../../components/AccountNickname/AccountNickname';

const Summary = () => {
  return (
    <TabWrapper>
      <AccountTypeSelect />
      <InstitutionNameInput />
      <AccountOwnerSelect />
      <AccountDescription />
      <AccountNickname />
      <Balance />
      <AccountEarmark />
      <Contributions label="Deposits" />
      <GrossEstateCheckbox />
      <BrokerOfRecord />
      <Liquidity />

      <ManagementStyle />

      <AssetBucketing />
    </TabWrapper>
  );
};

export const Checking = (props: FormComponentProps) => {
  return <TabsContent {...props} tabs={[{ name: 'Summary', Component: Summary }]} />;
};
